import React from 'react'
import { useLocation } from 'react-router-dom'
import { ThemeProvider } from 'react-jss'

import { useConfig } from '../../hooks/use-config'
import { getConfigValue } from '../../utils/getConfigValue'
import { SIGN_UP_SCREENS } from '../../constants'
import Header from '../../modules/sign-up/components/header'
import AsyncNavigationFooter from '../shared-navigation/navigation-footer'
import UseNotFoundProvider from '../../components/not-found/hooks/use-not-found-context'
import mainTheme from '../../theme'
import styles from './sign-up-layout.css'

const SignUpLayout = ({ children }) => {
  const location = useLocation()
  const { appConfig } = useConfig()

  // Get the hotspot image from config
  const guestBackgroundImageUrl = getConfigValue(appConfig?.values, 'GUEST_HOME_HOTSPOT_IMAGE')

  // Find the current sign-up screen based on location
  const currentScreen = Object.values(SIGN_UP_SCREENS).find(
    (screen) => screen.path === location.pathname
  )

  // Whether this screen should show a background image
  const shouldUseImageBackground =
    currentScreen?.hasBackgroundImage && Boolean(guestBackgroundImageUrl)

  // Inline styles only needed when an image background is used
  const imageBackgroundStyle = shouldUseImageBackground
    ? {
      backgroundImage: `
        linear-gradient(
          rgb(25, 25, 25) 40%,
          rgb(25, 25, 25, 0.3) 90%
        ),
        url(${guestBackgroundImageUrl})
      `,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      maxWidth: '100vw'
    }
    : undefined

  return (
    <ThemeProvider theme={mainTheme}>
      <UseNotFoundProvider>
        <div className={styles.layout}>
          <Header />

          <div
            className={styles.content}
            style={imageBackgroundStyle}
          >
            {children}
          </div>

          <AsyncNavigationFooter location={location} className={styles.footer} />
        </div>
      </UseNotFoundProvider>
    </ThemeProvider>
  )
}

export default SignUpLayout
